import { useRegisterSW } from "virtual:pwa-register/react";
import { Button } from "./ui";

/** 画面の新しい版が届いたときに出す（編集中に勝手に読み込み直さない） */
export function UpdatePrompt() {
  const {
    needRefresh: [needRefresh, setNeedRefresh],
    updateServiceWorker,
  } = useRegisterSW({
    onRegisteredSW(_url, reg) {
      // 1 時間ごとに新しい版を確認する
      if (reg) window.setInterval(() => void reg.update().catch(() => undefined), 60 * 60 * 1000);
    },
  });
  if (!needRefresh) return null;
  return (
    <div className="unsaved" role="status">
      <span>画面の新しい版があります。保存してから更新してください。</span>
      <div className="row">
        <Button size="sm" onClick={() => setNeedRefresh(false)}>
          後で
        </Button>
        <Button size="sm" variant="primary" onClick={() => void updateServiceWorker(true)}>
          更新する
        </Button>
      </div>
    </div>
  );
}
